import React from 'react';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

import Box from '@mui/material/Box';

import Main from './Main';
import Header from './Header';
import Navigation from './Navigation';
import {mislecAPI} from "../../util/axios";

function Dashboard({ children, user, updateUser, chats, fetchChats, courses }) {
    const [openNav, setOpenNav] = React.useState(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        if (!user) {
            if (sessionStorage.getItem('mISLec_access_token')) {
                mislecAPI.get(`/api/auth/verify`)
                    .catch(error => {
                        //  Expired session
                        sessionStorage.removeItem('mISLec_access_token');
                        navigate('/login', { state: { url: window.location.pathname } });
                    });
            } else {
                //  Expired session
                navigate('/login', { state: { url: window.location.pathname } });
            }
        }
    }, [user]);

    return (
        <>
            {user && (
                <>
                    <Header user={user} updateUser={updateUser} onOpenNav={() => setOpenNav(true)} />

                    <Box
                        sx={{
                            minHeight: 1,
                            display: 'flex',
                            flexDirection: { xs: 'column', lg: 'row' },
                        }}
                    >
                        <Navigation user={user} updateUser={updateUser} chats={chats} fetchChats={fetchChats} courses={courses} openNav={openNav} onCloseNav={() => setOpenNav(false)} />
                        <Main>{children}</Main>
                    </Box>
                </>
            )}
        </>
    );
}

Dashboard.propTypes = {
    children: PropTypes.node,
};

export default Dashboard;